import { ApolloClient, InMemoryCache } from '@apollo/client';
import { createHttpLink } from 'apollo-link-http';
import config from "../config";

export const MageQL = new ApolloClient({
    cache: new InMemoryCache(),
    link: createHttpLink({
        uri: `${config.magento.baseUrl}/graphql`,
    }),
});